import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { UserClaim } from '../models';

@Injectable({
  providedIn: 'root'
})
export class UserClaimService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

   
     /**
    * This method is used to get the search results of user claim
    * based on the parameters.
    *
    * @param  pageNo  current page number
    * @param  pageSize Number of records per page
    * @param  sortField field needed to sort
    * @param  sortOrder whether the sorting field is ascending or descending
    * @param  appliedFilters appliedFilters
    * @return      json result
    */
      public searchUserClaim(pageNo:number,pageSize:number,sortField:string,sortOrder:string,appliedFilters:{field:string,matchMode:string,value:string}[]=[]):Observable<any> {
        return this.apiService.get(`UserClaim/SearchUserClaim?pageNo=${pageNo}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}&appliedFilters=${appliedFilters}`)
      }
  
  
      /**
      * This method is used to get all user claim records, there is no parameter
      *
      * @return      json result
      */
       public getAllUserClaims(userClaimSearchParam:IGlobalSearchParam):Observable<any> {
        console.log(userClaimSearchParam);
        return this.apiService.post(`UserClaim/SearchUserClaim`,userClaimSearchParam)
      }
  
      /**
      * This method is used to get individual user claim record based on the claimsid
      *
      * @param  claimsId  
      * @return      json result
      */
       public getUserClaimById(claimsId:number):Observable<any> {
          return this.apiService.get(`UserClaim/${claimsId}`)
      }
  
      /**
      * This method is used to post/add new user claim record
      *
      * @param  UserClaim object which contains the claims record values
      * @return      json result
      */
       public postUserClaim(claimsMaster:UserClaim):Observable<any> {
          return this.apiService.post(`UserClaim`, claimsMaster)
      }
  
  
      /**
      * This method is used to update the existing user claim record
      *
      * @param  User Claim Id 
      * @param  UserClaim object which contains the claims record values
      * @return      json result
      */
       public updateUserClaim(claimsId:number, claimsMaster:UserClaim):Observable<any> {
          return this.apiService.put(`UserClaim/${claimsId}`, claimsMaster)
      }
  
  
      /**
      * This method is used to delete the existing user claim record
      *
      * @param  User Claim Id
      * @return      json result
      */
       public deleteUserClaim(claimsId:number):Observable<any> {
          return this.apiService.delete(`UserClaim/${claimsId}`)
      }

      getCompanyName():Observable<any>{
        return this.apiService.get(`CompanyProfile/AllApprovedCompanyList`)
      }

      getUserRole(companyId: number):Observable<any>{
        return this.apiService.get(`CompanyProfile/CompanyAllUserRolesList/${companyId}`)
      }

      getAllUserRole():Observable<any>{
        return this.apiService.get(`CompanyProfile/AllUserRolesList`)
      }
      
      getUserList(companyId: number, userRoleId: any, userName: string):Observable<any>{
        userName = (userName === undefined) ? null : userName;
        return this.apiService.get(`CompanyProfile/CompanyUsersByCriteria/${companyId}/${userRoleId}/${userName}`)
      }

      getUserClaimByUserProfileId(profileId: number):Observable<any>{
        return this.apiService.get(`UserClaim/UserClaimByUserProfileIdGroupFeature/${profileId}`)
      }

      postUserClaims(body: any):Observable<any>{
        return this.apiService.post(`UserClaim`, body)
      }
  
}
